import type { RouteObject } from 'react-router';

import { AuthLayout } from '@/features/auth/auth-layout';
import { RequireAuth } from '@/features/auth/guards';

import { ConnectAgentPage } from './connect-agent-page';

/**
 * Where an agent sends its user to approve it, in the auth screens' shell.
 * Signed out, it goes to sign-in and comes back; no onboarding guard, so
 * the page itself explains when there's no workspace yet.
 */
export const connectRoute: RouteObject = {
  element: (
    <RequireAuth>
      <AuthLayout />
    </RequireAuth>
  ),
  children: [{ path: 'connect/agent/:connectionId', element: <ConnectAgentPage /> }],
};
